// ═══════════════════════════════════════════════════════
// DALFA CONCEPT — Animations v2
// ═══════════════════════════════════════════════════════

(function() {
  'use strict';

  // ── Intersection Observer factory ──────────────────────
  function observe(selector, onEnter, threshold) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          onEnter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: threshold || 0.1 });
    document.querySelectorAll(selector).forEach(function(el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function() {

    // ── Hero animate-in ───────────────────────────────────
    document.querySelectorAll('.dalfa-hero-animate').forEach(function(el) {
      // Small delay so CSS transition fires after paint
      setTimeout(function() { el.classList.add('is-visible'); }, 80);
    });

    // ── Parallax ─────────────────────────────────────────
    var parallaxEls = document.querySelectorAll('.dalfa-parallax');
    if (parallaxEls.length) {
      window.addEventListener('scroll', function() {
        var scrollY = window.scrollY;
        parallaxEls.forEach(function(el) {
          var speed = parseFloat(el.dataset.parallaxSpeed || 0.1);
          var rect = el.closest('section') ? el.closest('section').getBoundingClientRect() : { top: 0 };
          var offset = (scrollY + rect.top) * speed;
          el.style.transform = 'translateY(' + offset + 'px)';
        });
      }, { passive: true });
    }

    // ── Word reveal (manifesto) ───────────────────────────
    document.querySelectorAll('.dalfa-word-reveal').forEach(function(el) {
      var text = el.textContent.trim();
      el.innerHTML = text.split(' ').map(function(word, i) {
        return '<span class="dalfa-word" style="transition-delay:' + (i * 0.06) + 's">' + word + '&nbsp;</span>';
      }).join('');
    });

    observe('.dalfa-word-reveal', function(el) {
      el.classList.add('is-visible');
    }, 0.2);

    // ── Stagger container ─────────────────────────────────
    observe('.dalfa-stagger-container', function(el) {
      el.classList.add('is-visible');
    }, 0.05);

    // ── Slide in (editorial) ──────────────────────────────
    observe('.dalfa-slide-left, .dalfa-slide-right', function(el) {
      el.classList.add('is-visible');
    }, 0.1);

    // ── Count-up animation ────────────────────────────────
    observe('.dalfa-count[data-target]', function(el) {
      var target = el.dataset.target;
      // If target is a number, animate; otherwise just show it
      var num = parseFloat(target.replace(/[^0-9.]/g, ''));
      var suffix = target.replace(/[0-9.]/g, '');
      if (!isNaN(num) && num > 0) {
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * num) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
    }, 0.2);

    // ── Marquee — pause on hover ──────────────────────────
    document.querySelectorAll('.dalfa-marquee-wrapper').forEach(function(wrapper) {
      var track = wrapper.querySelector('.dalfa-marquee-track');
      if (!track) return;
      wrapper.addEventListener('mouseenter', function() {
        track.style.animationPlayState = 'paused';
      });
      wrapper.addEventListener('mouseleave', function() {
        track.style.animationPlayState = 'running';
      });
    });

  });

})();
